import React, { useRef } from 'react';
import './contact.css';
import emailjs from '@emailjs/browser';

const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm('service_82zlnfw', 'template_i9obyfe', form.current, 'bxL5fhuI3WHYlFgVL')
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );

    e.target.reset();
  };

  return (
    <section className="contact section" id="contact">
      <h2 className="section__title">Get in touch</h2>
      <span className="section__subtitle">Contact Me</span>

      <div className="contact__container container grid">
        <div className="contact__content">
          <h3 className="contact__title">Talk to me</h3>

          <div className="contact__info">
            <div className="contact__card">
              <i className="bx bx-mail-send contact__card-icon"></i>
              <h3 className="contact__card-title">Email</h3>
              <span className="contact__card-data">shahade.abdulhamid@gmail.com</span>
              <a href="mailto:shahade.abdulhamid@gmail.com" className="contact__button">
                Write me <i className="bx bx-right-arrow-alt contact__button-icon"></i>
              </a>
            </div>
            <div className="contact__card">
              <i className="bx bxl-linkedin contact__card-icon"></i>
              <h3 className="contact__card-title">LinkedIn</h3>
              <span className="contact__card-data">abdulhamidshahade</span>
              <a href="https://www.linkedin.com/in/abdulhamidshahade/" target="_blank" rel="noreferrer" className="contact__button">
                Connect <i className="bx bx-right-arrow-alt contact__button-icon"></i>
              </a>
            </div>
          </div>
        </div>
        <div className="contact__content">
          <h3 className="contact__title">Write me your message</h3>

          <form ref={form} onSubmit={sendEmail} className="contact__form">
            <div className="contact__form-div">
              <label className="contact__form-tag">Name</label>
              <input type="name" name="name" className="contact__form-input" placeholder="Insert your name" />
            </div>
            <div className="contact__form-div">
              <label className="contact__form-tag">Mail</label>
              <input type="email" name="email" className="contact__form-input" placeholder="Insert your email" />
            </div>
            <div className="contact__form-div contact__form-area">
              <label className="contact__form-tag">Message</label>
              <textarea name="project" cols="30" rows="10" className="contact__form-input" placeholder="Write your message here."></textarea>
            </div>
            <button className="contact_button">
              Send Message
              <i className="bx bx-envelope contact__button-icon"></i>
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
